import './popup.component.scss'

import {enableBodyScroll, disableBodyScroll} from 'body-scroll-lock';

const popup = document.querySelector('.popup')

if (popup) {
  const openBtns = document.querySelectorAll('[data-popup-open]')
  const closeBtns = popup.querySelectorAll('.popup__close-btn, .popup__overlay')

  const content = popup.querySelector('.popup__wr-content')

  const open = e => {
    e.preventDefault()
    popup.classList.add('opened')

    disableBodyScroll(content)
  }
  const close = e => {
    e.preventDefault()
    popup.classList.remove('opened')

    popup.classList.add('closing')
    setTimeout(() => {
      popup.classList.remove('closing')
    }, 300)

    enableBodyScroll(content)
  }

  openBtns.forEach(btn => {
    btn.addEventListener('click', open)
  })
  closeBtns.forEach(btn => {
    btn.addEventListener('click', close)
  })
}